import { render, staticRenderFns } from "./DatatableHeader.vue?vue&type=template&id=5af6c5da"
import script from "./DatatableHeader.vue?vue&type=script&lang=js"
export * from "./DatatableHeader.vue?vue&type=script&lang=js"
import style0 from "./DatatableHeader.vue?vue&type=style&index=0&id=5af6c5da&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports